import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center h-8 px-1.5 py-0.5 gap-2 rounded bg-gray-200" }
const _hoisted_2 = { class: "flex items-baseline gap-0.5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl text-secondary50" }, "#", -1)
const _hoisted_4 = { class: "text-xl font-normal leading-7 tracking-[0.1px] text-secondary50" }
const _hoisted_5 = {
  key: 0,
  class: "flex items-center gap-1 mr-1"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-[11px] leading-tight text-center" }, " O ID secundário deve ser usado em cenários onde a vaga não pode ser encontrada pelo seu ID ", -1)
const _hoisted_7 = { class: "flex flex-col select-none leading-none" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-[8px] leading-[8px] font-normal tracking-[0.04px] text-secondary50" }, " ID Secundário ", -1)
const _hoisted_9 = { class: "text-[12px] leading-[12px] font-normal tracking-[0.06px] text-secondary50" }

import { mdiTooltipQuestionOutline } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'StationIdBadge',
  props: {
    stationId: {},
    doctorStationId: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-col px-1", { 'border-r border-white mr-1': _ctx.doctorStationId }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.stationId), 1)
      ])
    ], 2),
    (_ctx.doctorStationId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_v_tooltip, {
            location: "bottom",
            "max-width": 200
          }, {
            activator: _withCtx(({ props: tooltipProps }) => [
              _createElementVNode("div", _mergeProps(tooltipProps, { class: "cursor-help flex items-center justify-center" }), [
                _createVNode(_component_v_icon, {
                  icon: _unref(mdiTooltipQuestionOutline),
                  size: "16",
                  class: "text-primary"
                }, null, 8, ["icon"])
              ], 16)
            ]),
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, " #" + _toDisplayString(_ctx.doctorStationId), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})